import { render, staticRenderFns } from "./NotificationAlarm.vue?vue&type=template&id=20c4395a&scoped=true&"
import script from "./NotificationAlarm.vue?vue&type=script&lang=js&"
export * from "./NotificationAlarm.vue?vue&type=script&lang=js&"
import style0 from "./NotificationAlarm.vue?vue&type=style&index=0&id=20c4395a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c4395a",
  null
  
)

export default component.exports